var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"align-center justify-center fill-height"},[_c('v-col',{staticClass:"flex-shrink-1 flex-grow-0"},[_c('transition',{attrs:{"name":"fade-up","mode":"out-in","appear":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }